import React, {ReactNode} from "react";
import {withTranslation} from "react-i18next";
import {withHostApi} from "../../contexts/HostApiContext";
import {colorData} from "./iColorData";
import {hexToHSL} from "./ColorUtils/ColorUtils";
import {getRequestConfig, request} from "tunnel-commande/src/utils";
import Icons from "../Icons";
import {Input, FormGroup} from 'reactstrap';

interface SearchColorBrandProps {
  hostApi: string
  colorData:  (colorInfos: colorData) => void;
  typeTransfer: string
  marqueId: number | undefined
  luminositeCouleurTextile: number | null;
  t: (arg0: string) => ReactNode;
}

interface SearchColorBrandState {
  marqueId: number;
  colorId: number;
  lstColors?: lstColors[] | [];
  lstMarques?: lstMarques[] | [];
}

interface lstColors {
  hsl: { h: number; s: number; l: number; } | null;
  id: number,
  marqueId: number,
  couleur_libelle: string,
  c: string,
  m: string,
  j: string,
  n: string,
  hexadecimal: string
}

interface lstMarques {
  marqueId: number,
  libelle: string
}

class SearchColorBrand extends React.Component<SearchColorBrandProps, SearchColorBrandState> {
  constructor(props: SearchColorBrandProps) {
    super(props);
    this.state = {
      marqueId: 0,
      colorId: 0
    };
    this.handleChangeBrand = this.handleChangeBrand.bind(this);
    this.handleChangeColor = this.handleChangeColor.bind(this);
  }

  componentDidMount() {
    this.fetchBrand();
  }

  componentDidUpdate(prevProps: Readonly<SearchColorBrandProps>, prevState: Readonly<SearchColorBrandState>) {
    if(this.props.marqueId === 0 && prevProps.marqueId !== 0) {
      this.setState({
        marqueId: 0,
        colorId: 0,
        lstColors: []
      })
    }
  }

  private fetchColorsBrand(marqueId: number) {
    request("GET", `${this.props.hostApi}/colors-class/brand/${marqueId}`, {
      ...getRequestConfig()
    }).then((res) => {
      const resultat = res.data;
      resultat.c = Number(resultat.c);
      resultat.m = Number(resultat.m);
      resultat.j = Number(resultat.j);
      resultat.n = Number(resultat.n);
      this.setState({
        lstColors: resultat
      });
    }).catch((error) => {
      console.log(error);
    });
  }

  private fetchBrand() {
    request("GET", `${this.props.hostApi}/colors-class/brand`, {
      ...getRequestConfig()
    }).then((res) => {
      this.setState({
        lstMarques: res.data
      });
    }).catch((error) => {
      console.log(error);
    });
  }

  private handleChangeBrand(event: any) {
    this.setState({
      marqueId: event.target.value
    }, () => {
      this.fetchColorsBrand(event.target.value);
    });
  }

  private handleChangeColor(event: any) {
    this.setState({
      colorId: event.target.value
    }, () => {
      if(this.state.lstColors) {
        const colorInfos = this.state.lstColors.filter((elt: {id: number}) => elt.id == event.target.value)[0];
        if(this.state.colorId > 0 && colorInfos.hexadecimal) {
          if(typeof colorInfos.c === "string") {
            colorInfos.c = Number(colorInfos.c);
            colorInfos.m = Number(colorInfos.m);
            colorInfos.j = Number(colorInfos.j);
            colorInfos.n = Number(colorInfos.n);
          }
          colorInfos.hsl = hexToHSL(colorInfos.hexadecimal);
          this.props.colorData(colorInfos);
          if(Number(colorInfos.hsl?.l) >= Number(this.props.luminositeCouleurTextile)) {
            this.setState({
              colorId: 0
            });
          }
        }
      }
    });
  }

  render() {
    const selectMarque = () => {
      const lstMarques: JSX.Element[] = [];
      if(this.state.lstMarques) {
        for (const elt of this.state.lstMarques) {
          const str = elt.libelle;
          lstMarques.push(
              <option className={'text-capitalize'}  key={elt.marqueId} value={elt.marqueId}>
                {str}&nbsp;©
              </option>
          );
        }
        return (
          <FormGroup>
            <Input type="select" name="select" id="selectBrand" defaultValue={this.state.marqueId} value={this.state.marqueId}  onChange={this.handleChangeBrand}>
              <option key={0} value={0}>
                {this.props.t('select_brand')}
              </option>
              {lstMarques}
            </Input>
          </FormGroup>
        );
      }
    };

    const selectColors = () => {
      const lstColors: JSX.Element[] = [];
      if(this.state.lstColors && this.state.lstColors?.length > 0) {
        for (const elt of this.state.lstColors) {
          const strCapitalize = elt.couleur_libelle.toLowerCase();
          lstColors.push(
              <option className={'text-capitalize'}  key={elt.id} value={elt.id}>
                {strCapitalize}
              </option>
          );
        }
        return (

          <FormGroup className={'flex-grow-1'}>
            <Input type="select" name="select" id="selectColor" className={' w100'} defaultValue={this.state.colorId} value={this.state.colorId} onChange={this.handleChangeColor}>
              <option key={0} value={0}>
                {this.props.t('select_color')}
              </option>
              {lstColors}
            </Input>
          </FormGroup>
        );
      }
    };

    return (
        <div className={`${this.props.typeTransfer !== 'ce' ? 'display-none' : ' bg-lightgrey p-2 mb-2 '}`}>
          <p className={"bold m-0 px-1"}>{this.props.t('search_color_brand')}</p>
          <div className={" p-1"}>
            {this.state.lstMarques && selectMarque()}
            <div className={"d-flex mt2 align-items-start"}>
              {this.state.colorId > 0 && this.state.marqueId > 0 &&
                <span className={'pt-2  mr-2'}>
                <Icons icon="done" size={25} className={'green'}/>
                </span>
              }
              {this.state.lstColors && selectColors()}
            </div>
          </div>
          <p className={"small p-1 italic grey"}>{this.props.t('approximate_color')}</p>
        </div>
    );
  }
}
export default withTranslation('common')(withHostApi(SearchColorBrand));
